<formly-form class="form"
             [model]="model"
             [form]="tags"
             [fields]="[field]"></formly-form>
